export default {
  common: {
    appName: '떼창',
    loading: '로딩 중...',
    error: '오류가 발생했습니다',
    save: '저장',
    cancel: '취소',
    delete: '삭제',
    edit: '수정',
    confirm: '확인',
    close: '닫기',
    search: '검색',
    add: '추가',
    create: '생성',
    update: '업데이트',
    welcome: '환영합니다',
    logout: '로그아웃',
    login: '로그인',
    signup: '회원가입',
    and: '및'
  },
  header: {
    home: '홈',
    search: '검색',
    playlists: '플레이리스트',
    community: '커뮤니티',
    fanchantArchive: '떼창 아카이브',
    concerts: '공연정보',
    practice: '연습모드',
    profile: '프로필',
    admin: '관리자',
    bookmarks: '북마크',
    announcements: '공지사항',
    myPlaylists: '내 플레이리스트',
    newPlaylist: '새 플레이리스트'
  },
  home: {
    title: '🎯 떼창과 함께하는 특별한 음악 경험',
    subtitle: '좋아하는 K-POP, 발라드, 트로트까지!',
    subtitle2: '나만의 플레이리스트를 만들고 친구들과 함께 공유해보세요.',
    startButton: '지금 시작하기 →',
    feature1: '무제한 플레이리스트 생성',
    feature2: '30초 구간 연습 모드',
    feature3: '친구들과 플레이리스트 공유',
    myPlaylists: '{name}님의 플레이리스트',
    defaultUser: '사용자',
    guide: '가이드',
    noPlaylists: '아직 플레이리스트가 없습니다. 새로운 플레이리스트를 만들어보세요!',
    popularPlaylists: '🔥 인기 플레이리스트 TOP 10',
    recentPlaylists: '🆕 최근 생성된 플레이리스트',
    sortByPlays: '재생횟수',
    sortByCopies: '복사횟수',
    songs: '곡',
    songCount: '곡 수',
    copyCount: '복사 횟수',
    updatedAt: '업데이트',
    share: '공유',
    plays: '회 재생',
    copies: '회 복사',
    by: 'by',
    viewDetail: '👁️ 상세보기',
    copyPlaylist: '📋 복사하기'
  },
  search: {
    title: '노래 검색',
    tabMusic: '🎵 음악/영상 검색',
    tabPopular: '🔥 인기 플레이리스트',
    tabTags: '🏷️ 태그로 검색',
    guide: '가이드',
    placeholder: '노래 제목, 아티스트를 검색하세요',
    placeholderTag: '태그로 플레이리스트 검색',
    searching: '검색 중...',
    noResults: '검색 결과가 없습니다',
    tryAgain: '다른 검색어로 시도해보세요',
    recentSearches: '최근 검색',
    addToPlaylist: '플레이리스트에 추가',
    quotaExceeded: 'YouTube API 할당량이 초과되었습니다',
    tryLater: '나중에 다시 시도해주세요',
    todaySearch: '오늘 검색',
    remaining: '남은 검색',
    times: '회',
    quotaExhausted: '⚠️ 검색 횟수 소진',
    linkGuideTitle: '💎 무제한 검색 팁!',
    linkGuideTitleExceeded: '검색 횟수가 소진되었나요?',
    linkGuideText: 'YouTube 링크를 직접 입력하면',
    linkGuideHighlight: '검색 횟수를 소비하지 않고',
    linkGuideHighlightExceeded: '검색 횟수 차감 없이',
    linkGuideText2: '바로 검색할 수 있어요!',
    linkGuideExample: '예시: https://www.youtube.com/watch?v=videoId 또는 https://youtu.be/videoId',
    filterTitle: '검색 유형 (다중 선택 가능):',
    filterOfficial: '공식 영상',
    filterLyrics: '가사 영상',
    filterLive: '라이브',
    filterCover: '커버',
    filterAudio: '오디오',
    allPlaylists: '전체 플레이리스트',
    myPlaylists: '내 플레이리스트',
    popularTags: '🔥 인기 태그',
    recommendedKeywords: '🔍 추천 검색어',
    recentSearchesTitle: '최근 검색어',
    popularKeywords: '인기 검색어',
    noRecentSearches: '최근 검색어가 없습니다',
    quotaCacheMessage: '다음 검색어를 클릭하시면 캐시된 결과를 확인할 수 있습니다:',
    noCacheData: '현재 관련된 캐시 데이터가 없습니다. 다른 검색어를 시도해보세요.',
    // 검색 방법 탭
    searchByKeyword: '키워드 검색',
    searchByLink: '링크로 검색',
    // URL 입력
    urlPlaceholder: 'YouTube 링크를 입력하세요 (예: https://www.youtube.com/watch?v=...)',
    addToPlayer: '플레이어에 추가',
    urlHelp: 'YouTube, YouTube Music 링크를 지원합니다. 링크 검색은 할당량을 소비하지 않습니다.',
    loading: '로딩중...',
    // 알럿 메시지
    alertInvalidUrl: '올바른 YouTube URL이 아닙니다.',
    alertVideoInfoFailed: '비디오 정보를 가져오는데 실패했습니다.',
    alertSongAddedToPlayer: '플레이어에 추가되었습니다.',
    alertSongAddFailed: '곡 추가 실패'
  },
  playlist: {
    title: '플레이리스트',
    type: '플레이리스트',
    loading: '플레이리스트를 불러오는 중...',
    retry: '다시 시도',
    backToList: '목록으로 돌아가기',
    backToListShort: '← 목록으로',
    guide: '가이드',
    myPlaylists: '내 플레이리스트',
    publicPlaylists: '공개 플레이리스트',
    createNew: '새 플레이리스트',
    editPlaylist: '플레이리스트 수정',
    deletePlaylist: '플레이리스트 삭제',
    playlistName: '플레이리스트 이름',
    description: '설명',
    descriptionPlaceholder: '플레이리스트 설명을 입력하세요...',
    isPublic: '공개',
    isPrivate: '비공개',
    clickToPublic: '클릭하여 공개로 변경',
    clickToPrivate: '클릭하여 비공개로 변경',
    editTitle: '제목 편집',
    editDescription: '설명 편집',
    songs: '곡',
    addSongs: '곡 추가',
    removeSong: '곡 제거',
    playSong: '재생',
    playAll: '전체 재생',
    shuffle: '셔플 재생',
    confirmDelete: '정말 삭제하시겠습니까?',
    emptySongList: '곡이 없습니다',
    addFirstSong: '첫 곡을 추가해보세요',
    createdBy: '만든 사람',
    totalDuration: '총 재생시간',
    songList: '곡 목록',
    saveBtn: '저장',
    cancelBtn: '취소',
    totalCopies: '총 복사수',
    times: '회',
    share: '공유',
    shareDropdown: '공유 ▼',
    shareToCommunity: '커뮤니티에 공유',
    unshareToCommunity: '커뮤니티 공유 취소',
    copyLink: '링크 복사',
    copyToMyPlaylist: '내 플레이리스트로 복사',
    privatePlaylist: '비공개 플레이리스트',
    shareOnlyPublic: '공개 플레이리스트만 공유할 수 있습니다',
    tags: '태그',
    comments: '댓글',
    showComments: '댓글 보기',
    hideComments: '댓글 숨기기',
    sortBy: '정렬:',
    sortCustom: '사용자 지정 순서',
    sortTitle: '제목 순',
    sortArtist: '아티스트 순',
    sortAddedDate: '추가일 순',
    sortDuration: '재생시간 순',
    tableTitle: '제목',
    tableArtist: '아티스트',
    tableAlbum: '앨범',
    tableAddedDate: '추가일',
    tableDuration: '재생시간',
    addToQueueNext: '현재 곡 다음에 추가',
    addToQueueLast: '재생목록 마지막에 추가',
    removeFromPlaylist: '플레이리스트에서 삭제',
    emptyPlaylist: '플레이리스트가 비어있습니다',
    addSongsToStart: '곡을 추가해보세요',
    recentActivity: '최근 활동',
    copyPlaylistModal: '플레이리스트 복사',
    copyPlaylistConfirm: '이 플레이리스트를 내 플레이리스트로 복사하시겠습니까?',
    copyWarning: '복사된 플레이리스트는 내 플레이리스트 목록에 추가됩니다.',
    copyBtn: '복사하기',
    addSongModal: '곡 추가',
    addBySearch: '검색으로 추가',
    addByLink: '링크로 추가',
    searchPlaceholder: '아티스트명이나 곡명을 검색하세요...',
    todaySearches: '오늘 검색:',
    remaining: '남은 검색:',
    quotaExhausted: '검색 횟수 소진',
    linkAddTip: '무제한 검색 팁!',
    linkAddTipExhausted: '검색 횟수가 소진되었나요?',
    linkAddDesc1: '링크로 추가 탭을 사용하면',
    linkAddHighlight: '검색 횟수 차감 없이',
    linkAddHighlightAlt: '검색 횟수를 소비하지 않고',
    linkAddDesc2: '바로 추가할 수 있어요!',
    linkAddInstruction: '위 탭에서 "🔗 링크로 추가"를 선택하세요',
    urlPlaceholder: 'YouTube URL을 입력하세요... (예: https://www.youtube.com/watch?v=...)',
    urlSupport: 'YouTube, YouTube Music 링크를 지원합니다',
    searchResults: '검색 결과',
    items: '개',
    viewCount: '회 조회',
    prevPage: '이전',
    nextPage: '다음',
    pageInfo: '페이지',
    searching: '검색 중...',
    noResults: '검색 결과가 없습니다',
    closeModal: '닫기',
    loading: '로딩...',
    // Additional translations for script messages
    hour: '시간',
    minute: '분',
    noDescription: '설명이 없습니다.',
    // Alert messages
    alertTitleRequired: '플레이리스트 제목은 비워둘 수 없습니다.',
    alertUpdateFailed: '플레이리스트 업데이트에 실패했습니다.',
    alertSongsAddedToQueue: '{count}곡이 재생목록에 추가되었습니다',
    alertSongsAddedShuffled: '{count}곡이 재생목록에 추가되었습니다 (셔플)',
    alertSongRemoveFailed: '곡 삭제에 실패했습니다.',
    alertSharedToCommunity: '플레이리스트가 커뮤니티에 공유되었습니다!',
    alertUnsharedFromCommunity: '커뮤니티 공유가 취소되었습니다.',
    alertCommunityShareFailed: '❌ 커뮤니티 공유 처리에 실패했습니다.',
    alertPlaylistCopied: '"{name}" 플레이리스트가 내 플레이리스트로 복사되었습니다!',
    alertCannotCopyOwn: '자신의 플레이리스트는 복사할 수 없습니다.',
    alertCopyFailed: '❌ 플레이리스트 복사에 실패했습니다.',
    alertMadePublic: '✅ 플레이리스트가 공개로 변경되었습니다!\n이제 공유할 수 있습니다.',
    alertMakePublicFailed: '❌ 플레이리스트 공개 설정에 실패했습니다.',
    alertPrivacyChangedPublic: '🌍 플레이리스트가 공개로 변경되었습니다!\n이제 다른 사용자들이 볼 수 있고 공유할 수 있습니다.',
    alertPrivacyChangedPrivate: '🔒 플레이리스트가 비공개로 변경되었습니다!\n이제 본인만 볼 수 있습니다.',
    alertPrivacyChangeFailed: '❌ 플레이리스트 공개/비공개 설정에 실패했습니다.',
    alertDeleted: '플레이리스트가 성공적으로 삭제되었습니다.',
    alertDeleteFailed: '플레이리스트 삭제에 실패했습니다.',
    alertSearchFailed: '검색에 실패했습니다: {message}',
    alertSongAdded: '✅ "{title}"이(가) 플레이리스트에 추가되었습니다.',
    alertSongAddFailed: '곡 추가에 실패했습니다: {message}',
    alertInvalidUrl: '올바른 YouTube URL이 아닙니다.',
    alertVideoInfoFailed: '비디오 정보 가져오기 실패: {status}',
    // Confirm messages
    confirmRemoveSong: '이 곡을 플레이리스트에서 삭제하시겠습니까?',
    confirmClearPlaylist: '정말로 이 플레이리스트의 모든 곡을 삭제하시겠습니까?',
    confirmDeletePlaylist: '"{name}" 플레이리스트를 완전히 삭제하시겠습니까?\n\n이 작업은 되돌릴 수 없습니다.',
    confirmMakePublic: '🔒 이 플레이리스트는 비공개 상태입니다.\n\n공유하려면 플레이리스트를 공개로 설정해야 합니다.\n\n지금 공개로 변경하시겠습니까?',
    confirmPrivacyChange: '플레이리스트를 {currentStatus}에서 {newStatus}로 변경하시겠습니까?\n\n{details}',
    privacyDetailsPublic: '• 공개로 변경하면 다른 사용자들이 이 플레이리스트를 볼 수 있습니다.\n• 공유 링크를 생성할 수 있습니다.',
    privacyDetailsPrivate: '• 비공개로 변경하면 다른 사용자들이 이 플레이리스트를 볼 수 없습니다.\n• 기존 공유 링크는 "비공개 플레이리스트" 안내가 표시됩니다.',
    statusPublic: '공개',
    statusPrivate: '비공개',
    // Error messages
    errorNotFound: '❌ 플레이리스트를 찾을 수 없습니다.',
    errorForbidden: '🔒 이 플레이리스트에 접근할 권한이 없습니다.',
    errorServerError: '⚠️ 서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
    errorLoadFailed: '❌ 플레이리스트를 불러오는데 실패했습니다.',
    errorNetworkFailed: '🌐 네트워크 연결을 확인해주세요.'
  },
  player: {
    play: '재생',
    pause: '일시정지',
    previous: '이전',
    next: '다음',
    repeat: '반복',
    shuffle: '셔플',
    volume: '볼륨',
    selectSong: '재생할 곡을 선택하세요',
    playlist: '재생 목록',
    songsCount: '곡',
    clearAll: '재생목록 전체 삭제',
    removeFromPlaylist: '재생목록에서 제거',
    lyrics: '가사',
    subtitle: '자막',
    noSubtitle: '자막 없음',
    sections: '구간',
    sectionManagement: '구간 관리',
    addSection: '구간 추가',
    sectionSelect: '구간 선택',
    sectionSelecting: '📐 구간 선택 중...',
    selectedSection: '선택된 구간',
    sectionRepeat: '구간 반복',
    sectionRepeating: '반복중',
    saveSection: '구간 저장',
    deleteSection: '선택된 구간 삭제',
    sectionSaveModal: '🎵 구간 저장',
    sectionName: '구간 이름',
    sectionNamePlaceholder: '예: 후렴구, 브릿지, 킬링파트 등',
    sectionLyrics: '가사/자막',
    sectionLyricsPlaceholder: '떼창이나 따라 부를 부분의 가사를 입력하면 연습에 도움이 됩니다.',
    pronunciation: '한글 발음',
    pronunciationPlaceholder: '한국어가 아닌 가사의 경우 발음 표기를 추가할 수 있습니다.',
    required: '*',
    cancel: '취소',
    save: '저장',
    startTime: '시작 시간',
    endTime: '종료 시간',
    noLyrics: '가사가 없습니다',
    loading: '로딩 중...',
    player: '플레이어',
    openPlayer: '플레이어 열기',
    closePlayer: '플레이어 닫기',
    expandFullscreen: '전체화면으로 보기',
    closeFullscreen: '전체화면 닫기',
    clearAllPlaylist: '전체 삭제',
    selectSongPlaceholder: '곡을 선택해주세요',
    artist: '아티스트',
    upcomingSection: '초 후',
    section: '구간',
    sectionTime: '구간:',
    repeatMode: '반복',
    deleteBtn: '삭제',
    saveBtn: '저장',
    lyricsSaveModal: '🎤 가사 구간 저장',
    lyricsEditModal: '🎤 가사 구간 수정',
    lyricsText: '가사',
    lyricsTextPlaceholder: '이 구간의 가사를 입력하세요',
    pronunciationGuide: '발음 기호',
    pronunciationGuidePlaceholder: '한국어가 아닌 가사의 경우 발음 표기를 추가할 수 있습니다.',
    lineNumber: '줄 번호',
    lineNumberPlaceholder: '가사 순서 (정렬용)',
    shareWithOthers: '다른 사용자와 공유하기',
    confirmRemoveSong: '이 곡을 플레이어에서 제거하시겠습니까?',
    confirmClearPlaylist: '재생목록을 모두 삭제하시겠습니까?',
    confirmDeleteLyrics: '"{name}" 가사 구간을 삭제하시겠습니까?',
    alertLyricsRequired: '가사 구간 이름과 가사를 입력해주세요.',
    alertLyricsUpdated: '가사 구간 "{name}"이 수정되었습니다!',
    alertLyricsSaved: '가사 구간 "{name}"이 저장되었습니다!',
    alertLyricsSaveFailed: '가사 구간 저장에 실패했습니다. 다시 시도해주세요.',
    alertLyricsDeleted: '"{name}" 가사 구간이 삭제되었습니다.',
    alertLyricsDeleteFailed: '가사 구간 삭제에 실패했습니다. 다시 시도해주세요.',
    errorInvalidVideo: '동영상 ID가 잘못되었습니다',
    errorHtml5: 'HTML5 플레이어에서 재생할 수 없는 콘텐츠입니다',
    errorNotFound: '동영상을 찾을 수 없습니다 (삭제되었거나 비공개)',
    errorEmbedNotAllowed: '동영상 소유자가 임베드를 허용하지 않습니다',
    errorUnknown: '알 수 없는 오류',
    errorCode: '코드'
  },
  profile: {
    title: '프로필',
    loading: '프로필 정보를 불러오는 중...',
    error: '오류가 발생했습니다',
    retry: '다시 시도',
    changeImage: '📷 이미지 변경',
    nickname: '닉네임',
    nicknameDefault: '닉네임을 설정하세요',
    nicknamePlaceholder: '닉네임을 입력하세요',
    save: '저장',
    cancel: '취소',
    username: '사용자명',
    email: '이메일',
    emailNotRegistered: '이메일 미등록',
    emailNotification: '이메일 알림',
    provider: 'OAuth 제공자',
    createdAt: '가입일',
    lastLoginAt: '최근 로그인',
    profileImage: '프로필 이미지',
    updateProfile: '프로필 업데이트',
    updateSuccess: '프로필이 업데이트되었습니다',
    updateFailed: '프로필 업데이트에 실패했습니다',
    nicknameUpdateSuccess: '닉네임이 저장되었습니다',
    nicknameUpdateFailed: '닉네임 저장에 실패했습니다',
    imageUpdateSuccess: '프로필 이미지가 변경되었습니다',
    imageUpdateFailed: '이미지 업로드에 실패했습니다'
  },
  admin: {
    dashboard: '대시보드',
    stats: '서비스 통계',
    users: '사용자 관리',
    playlists: '플레이리스트',
    reports: '댓글 신고',
    announcements: '공지사항',
    concerts: '공연 정보',
    settings: '시스템 설정',
    backToUser: '사용자 페이지로',
    searchStats: '검색 통계',
    apiUsage: 'API 사용량',
    userActivity: '사용자 활동',
    contentStats: '콘텐츠 통계',
    popularQueries: '인기 검색어',
    cacheHitRate: '캐시 히트율',
    dailySearches: '일별 검색량',
    totalApiCalls: '총 API 호출',
    avgDailyUsage: '일평균 사용량',
    quotaUsageRate: '할당량 사용률',
    dau: 'DAU',
    wau: 'WAU',
    mau: 'MAU',
    newUsers: '신규 가입자',
    activeUsers: '활성 사용자',
    totalPlaylists: '총 플레이리스트',
    totalSongs: '총 곡 수',
    publicRate: '공개율',
    period: '기간',
    days7: '7일',
    days14: '14일',
    days30: '30일',
    days90: '90일'
  },
  concerts: {
    title: '공연 정보',
    upcoming: '다가오는 공연',
    past: '지난 공연',
    date: '날짜',
    venue: '장소',
    artist: '아티스트',
    tickets: '티켓 예매',
    noUpcoming: '예정된 공연이 없습니다',
    guide: '가이드',
    guideTitle: '사용 가이드',
    domestic: '국내 공연',
    global: '해외 공연',
    dateSelect: '날짜 선택:',
    today: '오늘',
    concertsCount: '개의 공연',
    page: '페이지',
    total: '총',
    items: '개',
    gridView: '그리드',
    listView: '리스트',
    loading: '공연 정보를 불러오는 중...',
    venueUndecided: '장소 미정',
    createPlaylist: '플레이리스트 생성',
    bookTickets: '티켓 예매',
    noConcerts: '선택한 날짜에 공연이 없습니다',
    tryOtherDate: '다른 날짜를 선택해보세요',
    prev: '이전',
    next: '다음',
    playlistModal: '플레이리스트 생성',
    playlistName: '플레이리스트 이름',
    playlistNamePlaceholder: '플레이리스트',
    searchKeyword: '검색 키워드',
    searchKeywordPlaceholder: '검색할 키워드 입력',
    searching: '검색 중...',
    search: '검색',
    quotaExceededTitle: 'YouTube API 할당량이 초과되었습니다',
    quotaExceededDesc: '다음 검색어를 클릭하시면 캐시된 결과를 확인할 수 있습니다:',
    quotaExceededNoCache: '현재 관련된 캐시 데이터가 없습니다. 다른 검색어를 시도해보세요.',
    recommendedQueries: '추천 검색어',
    searchResults: '검색 결과',
    songs: '곡',
    add: '추가',
    remove: '제거',
    loadingMore: '로딩 중...',
    loadMore: '더 보기',
    currentPlaylist: '플레이리스트',
    cancel: '취소',
    saving: '저장 중...',
    savePlaylist: '플레이리스트 저장',
    playlistModalTitle: '{title} 플레이리스트 생성',
    alertEnterKeyword: '검색 키워드를 입력해주세요.',
    alertSearchError: '검색 중 오류가 발생했습니다.',
    alertRecommendedError: '추천 검색어 조회 중 오류가 발생했습니다.',
    alertAddSongs: '플레이리스트에 곡을 추가해주세요.',
    alertEnterName: '플레이리스트 이름을 입력해주세요.',
    alertPlaylistSaved: '플레이리스트 "{name}"가 성공적으로 생성되었습니다! ({count}곡)',
    alertPlaylistError: '플레이리스트 저장 중 오류가 발생했습니다.',
    statusOnSale: '예매중',
    statusSoldOut: '매진',
    statusUpcoming: '예매예정',
    statusEnded: '종료'
  },
  practice: {
    title: '연습 모드',
    selectSong: '노래를 선택하세요',
    selectSection: '연습할 구간을 선택하세요',
    startPractice: '연습 시작',
    repeat: '반복 횟수',
    speed: '재생 속도',
    normal: '보통',
    slow: '느리게',
    fast: '빠르게'
  },
  auth: {
    loginTitle: '로그인',
    signupTitle: '회원가입',
    loginWithGoogle: 'Google로 로그인',
    loginWithNaver: '네이버로 로그인',
    loginWithKakao: '카카오로 로그인',
    loginRequired: '로그인이 필요합니다',
    loginSuccess: '로그인되었습니다',
    logoutSuccess: '로그아웃되었습니다',
    // 로그인 모달
    welcomeTitle: '떼창에 오신 것을 환영합니다!',
    welcomeSubtitle: '간편하게 로그인하고 나만의 플레이리스트를 만들어보세요',
    simpleLogin: '간편 로그인',
    startWithGoogle: '구글로 시작하기',
    startWithNaver: '네이버로 시작하기',
    guestMode: '게스트 모드로 체험하기',
    guestNotice: '※ YouTube API 심사 및 데모 목적으로 제공되는 임시 기능입니다',
    loginAgreement: '로그인 시',
    termsOfService: '이용약관',
    privacyPolicy: '개인정보처리방침',
    agreementSuffix: '에 동의한 것으로 간주됩니다.',
    // 다중로그인 확인
    multiLoginTitle: '이미 로그인된 계정이 있습니다',
    multiLoginMessage1: '현재 다른 기기에서 로그인되어 있습니다.',
    multiLoginMessage2: '계속 진행하시면 기존 로그인이 자동으로 해제됩니다.',
    existingSessions: '기존 로그인 세션:',
    deviceWeb: '웹 브라우저',
    deviceMobile: '모바일 앱',
    minutesAgo: '{minutes}분 전',
    hoursAgo: '{hours}시간 전',
    daysAgo: '{days}일 전',
    cancelBtn: '취소',
    forceLoginBtn: '기존 로그인 해제하고 계속'
  },
  footer: {
    termsOfService: '이용약관',
    privacyPolicy: '개인정보처리방침',
    youtubeTerms: 'YouTube 이용약관',
    googlePrivacy: 'Google 개인정보처리방침',
    copyright: '© 2025 떼창(Ttaechang). All rights reserved.',
    youtubeApiNotice: '본 서비스는 YouTube API Services를 사용합니다.',
    madeBy: '제작:',
    contact: '문의:'
  },
  playlistList: {
    title: '내 플레이리스트',
    subtitle: '나만의 떼창 플레이리스트를 만들고 관리하세요',
    createBtn: '새 플레이리스트 만들기',
    statTotal: '총 플레이리스트',
    statSongs: '총 곡 수',
    statPublic: '공개 플레이리스트',
    statCopies: '총 복사수',
    viewGrid: '그리드',
    viewList: '리스트',
    sortRecent: '최근 수정순',
    sortName: '이름순',
    sortSongs: '곡 수순',
    sortCreated: '생성일순',
    filterAll: '전체',
    filterPublic: '공개',
    filterPrivate: '비공개',
    searchPlaceholder: '플레이리스트 검색...',
    loading: '플레이리스트를 불러오는 중...',
    retryBtn: '다시 시도',
    songs: '곡',
    public: '공개',
    private: '비공개',
    tooltipEdit: '편집',
    tooltipShare: '공유',
    tooltipDelete: '삭제',
    tablePlaylist: '플레이리스트',
    tableSongCount: '곡 수',
    tablePublicSetting: '공개 설정',
    tableUpdatedDate: '수정일',
    tableActions: '작업',
    noPlaylists: '플레이리스트가 없습니다',
    noPlaylistsSub: '첫 번째 플레이리스트를 만들어보세요',
    createPlaylistBtn: '플레이리스트 만들기',
    modalCreate: '새 플레이리스트 만들기',
    modalName: '플레이리스트 이름',
    modalNamePlaceholder: '예: BTS 떼창 모음',
    modalDescription: '설명',
    modalDescriptionPlaceholder: '이 플레이리스트에 대한 설명을 작성해주세요',
    modalPublicCheckbox: '공개 플레이리스트로 만들기',
    modalTags: '태그 (쉼표로 구분)',
    modalTagsPlaceholder: '예: 떼창, BTS, 초보자용',
    modalTagsHint: '여러 태그를 쉼표(,)로 구분해서 입력하세요',
    modalCancel: '취소',
    modalCreate: '만들기',
    // formatDate
    today: '오늘',
    yesterday: '어제',
    daysAgo: '{days}일 전',
    weeksAgo: '{weeks}주 전',
    unknown: '알 수 없음',
    // Activities
    activityCreated: '"{name}" 플레이리스트 생성',
    activityEdited: '"{name}" 플레이리스트 편집',
    activityShared: '"{name}" 플레이리스트 공유',
    activityNone: '아직 활동이 없습니다',
    activityNoneSub: '플레이리스트를 만들어보세요!',
    // Alerts
    alertDeleteConfirm: '"{name}" 플레이리스트를 삭제하시겠습니까?',
    alertDeleteFailed: '플레이리스트 삭제에 실패했습니다.',
    alertLoadFailed: '플레이리스트를 불러올 수 없습니다: {message}',
    alertCreateFailed: '플레이리스트 생성에 실패했습니다',
    alertNoDescription: '새로운 플레이리스트',
    alertJustNow: '방금 전',
    // Others
    noUserId: '사용자 ID가 없습니다',
    loadingSongs: '곡 로딩 중...',
    noSongInfo: '곡 정보 없음',
    unknownArtist: '알 수 없음',
    noTitle: '제목 없음'
  },

  // PlaylistFeed (커뮤니티 플레이리스트 피드)
  playlistFeed: {
    title: '🎵 플레이리스트 공유 게시판',
    description: '다른 사용자들이 공유한 플레이리스트를 탐색하고 마음에 드는 플레이리스트를 북마크하세요',
    searchPlaceholder: '플레이리스트 제목, 설명, 작성자, 태그로 검색...',
    searchBtn: '🔍 검색',
    sortRecent: '최신순',
    sortPopular: '인기순',
    sortMostLiked: '좋아요순',
    sortMostViewed: '조회수순',
    sortMostCopied: '복사순',
    sortMostBookmarked: '북마크순',
    filterAllSongs: '모든 곡 수',
    filter5Plus: '5곡 이상',
    filter10Plus: '10곡 이상',
    filter20Plus: '20곡 이상',
    popularTagsTitle: '🏷️ 인기 태그',
    selectedTagsLabel: '선택된 태그:',
    clearAllTags: '모두 지우기',
    loading: '플레이리스트를 불러오는 중...',
    retryBtn: '다시 시도',
    songs: '곡',
    noDescription: '설명 없음',
    authorLabel: '작성자:',
    emptyState: '공개된 플레이리스트가 없습니다',
    prevPage: '◀ 이전',
    nextPage: '다음 ▶',
    loadError: '플레이리스트를 불러오는데 실패했습니다.',
    bookmarkError: '북마크 처리에 실패했습니다.',
    thumbnailAlt: '곡 {index} 썸네일'
  },

  // FanchantArchive (떼창 영상 아카이브)
  fanchantArchive: {
    title: '🎬 떼창 영상 아카이브',
    description: 'K-pop 콘서트의 감동적인 떼창 순간들을 모아보세요',
    guideBtn: '가이드',
    guideBtnTooltip: '사용 가이드',
    searchPlaceholder: '아티스트나 곡명으로 떼창 영상 검색...',
    searchBtn: '🔍 검색',
    tabTrendingShorts: '급인기 쇼츠',
    tabTrendingRegular: '급인기 일반',
    tabPopularShorts: '누적인기 쇼츠',
    tabPopularRegular: '누적인기 일반',
    tabSearch: '검색',
    loading: '떼창 영상을 불러오는 중...',
    retryBtn: '다시 시도',
    totalVideos: '총 {count}개 영상',
    displayedVideos: '({displayed}개 표시)',
    lastUpdate: '마지막 업데이트: {date}',
    searchResultTitle: '🔍 "{query}" 검색 결과',
    emptySearch: '검색 결과가 없습니다',
    emptySearchSub: '다른 검색어로 시도해보세요',
    emptyDefault: '떼창 영상을 검색해보세요!',
    emptyDefaultSub: '아티스트 이름이나 곡명을 입력하여 감동적인 떼창 순간들을 찾아보세요',
    videoSuffix: '떼창 영상',
    loadTrendingShortsError: '급인기 쇼츠 떼창 영상을 불러오는데 실패했습니다.',
    loadTrendingRegularError: '급인기 일반 떼창 영상을 불러오는데 실패했습니다.',
    loadPopularShortsError: '누적인기 쇼츠 떼창 영상을 불러오는데 실패했습니다.',
    loadPopularRegularError: '누적인기 일반 떼창 영상을 불러오는데 실패했습니다.',
    searchError: '검색에 실패했습니다.',
    searchNotFound: '"{query}"에 대한 떼창 영상을 찾을 수 없습니다. 다른 검색어를 시도해보세요.'
  },

  // Pagination (페이징)
  pagination: {
    previous: '이전',
    next: '다음',
    previousPage: '이전 페이지',
    nextPage: '다음 페이지',
    itemsCount: '{start}-{end} / {total}개'
  },

  // Comments (댓글)
  comments: {
    title: '💬 댓글',
    count: '{count}개',
    sortLatest: '최신순',
    sortPopular: '인기순',
    writePlaceholder: '댓글을 작성해보세요...',
    cancel: '취소',
    submitting: '작성 중...',
    submit: '댓글 작성',
    loginRequired: '댓글을 작성하려면',
    loginLink: '로그인',
    loginRequiredSuffix: '이 필요합니다.',
    loading: '댓글을 불러오는 중...',
    noComments: '아직 댓글이 없습니다.',
    firstComment: '첫 번째 댓글을 작성해보세요!',
    loadMore: '더 많은 댓글 보기',
    replyTitle: '답글 작성',
    replyTo: '{name}님에게 답글',
    replyPlaceholder: '답글을 작성해보세요...',
    replySubmitting: '작성 중...',
    replySubmit: '답글 작성',
    reportTitle: '댓글 신고',
    reportReason: '신고 사유',
    reportReasonPlaceholder: '사유를 선택하세요',
    reportReasonSpam: '스팸/도배',
    reportReasonAbuse: '욕설/비방',
    reportReasonInappropriate: '부적절한 내용',
    reportReasonHate: '혐오/차별',
    reportReasonOther: '기타',
    reportDescription: '상세 설명 (선택사항)',
    reportDescriptionPlaceholder: '신고 사유에 대한 상세한 설명을 입력해주세요...',
    reportSubmitting: '신고 중...',
    reportSubmit: '신고하기',
    alertLoginRequired: '로그인이 필요합니다.',
    alertCommentFailed: '댓글 작성에 실패했습니다.',
    alertReplyFailed: '답글 작성에 실패했습니다.',
    alertEditFailed: '댓글 수정에 실패했습니다.',
    alertDeleteConfirm: '정말로 이 댓글을 삭제하시겠습니까?',
    alertDeleteFailed: '댓글 삭제에 실패했습니다.',
    alertReportSuccess: '신고가 접수되었습니다.',
    alertReportFailed: '신고 처리에 실패했습니다.'
  },

  // Announcements (공지사항)
  announcements: {
    title: '공지사항',
    loading: '공지사항을 불러오는 중...',
    noAnnouncements: '공지사항이 없습니다.',
    readMore: '자세히 보기',
    back: '뒤로',
    backToList: '목록으로 돌아가기',
    notFound: '공지사항을 찾을 수 없습니다.',
    loadError: '공지사항을 불러오는데 실패했습니다.'
  }
}
